import moment from 'moment';
// import 'moment-timezone';

import store from '@/store/index';
import { DEFAULT_TZ } from '@/constants';


export const getTimezone = () => {
  // const currentUser = store.getters['entities/users/find'](userId) || store.getters['entities/users/currentUser'];
  const browserTimezone = moment.tz.guess();

  return browserTimezone;
};

export const inTimezone = (momentObj, user = null) => momentObj.tz(getTimezone(user));

export const getLocale = () => {
  const currentUser = store.getters['entities/users/currentUser'];

  return currentUser.language || DEFAULT_TZ;
};



// WEBPACK FOOTER //
// ./src/utils/time.js